import React, { Component } from 'react'
import styled from 'styled-components'
import { styles, utils, translations } from 'gipsy-misc'
import { Icon, LabelIcon, media, Tooltip } from 'gipsy-ui'

import FaRetweet from 'react-icons/lib/fa/retweet'

export const AllDayEventBadge = () => <span className="bounds-date">All day event</span>

export const WhenBadge = ({ when }) => <span className="when">{when}</span>

const TimeReminder = styled.span`
  color: ${styles.colors.pinkColor};
  background-color: ${styles.colors.lightPink};

  padding: 0 8px;
  border-radius: 8px;

  @keyframes flickerAnimation {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
  & > * {
    animation: flickerAnimation 2s infinite;
  }
`

export const PinTimeBadge = ({
  item,
  isPinTimePast,
  pinTime,
  isCompleted,
  shouldDisplayText,
  isStartingSoon,
  isInProgress,
  diffMinutes
}) => {
  return (
    <span className={'pin' + (!isCompleted && isPinTimePast ? ' overdue' : '')}>
      {item.type === 'task' && (
        <PinIcon
          icon="Pin"
          fill="white"
          size={24}
          backgroundColor={!isCompleted && isPinTimePast ? styles.colors.pinkColor : styles.colors.darkGrey}
        />
      )}
      {shouldDisplayText && <span>{pinTime}</span>}
      {isStartingSoon && (
        <TimeReminder>
          <span>{translations.todolist.startsIn.replace('$diffMinutes', diffMinutes)}</span>
        </TimeReminder>
      )}
      {isInProgress && (
        <TimeReminder>
          <span>{translations.todolist.inProgress}</span>
        </TimeReminder>
      )}
    </span>
  )
}

const PinIcon = styled(Icon)`
  border-radius: 10px;
  padding: 6px;
  margin-right: 8px;
  background-color: ${props => props.backgroundColor};
`

export const PinDateBadge = ({ item, isPinDatePast, pinDate, isCompleted, shouldDisplayText }) => (
  <span className={'pin' + (!isCompleted && isPinDatePast ? ' overdue' : '')}>
    {item.type === 'task' && (
      <PinIcon
        icon="Pin"
        fill="white"
        size={24}
        backgroundColor={!isCompleted && isPinDatePast ? styles.colors.pinkColor : styles.colors.darkGrey}
      />
    )}
    {shouldDisplayText ? <span>{pinDate}</span> : ''}
  </span>
)

export const DeadlineBadge = ({ item, isDeadlinePast, isCompleted }) => (
  <LabelIcon
    className="deadline"
    icon="Deadline"
    color={!isCompleted && isDeadlinePast ? 'pink' : null}
    value={utils.datetime.humanizeDate(item.dueDate)}
  />
)

export const ETABadge = ({ text }) => (
  <span className="eta">
    <span>ETA {text}</span>
  </span>
)

export const CompletionTimeBadge = ({ text }) => (
  <span className="completion-time">
    <span>{text}</span>
  </span>
)

/* ********* New Badge ********* */

const NewBadgeContainer = styled.span`
  text-transform: uppercase;
  font-weight: 600;
  padding: 0 8px;
  border-radius: 10px;
  background: ${styles.colors.greenColor};
  font-size: 10px;
  color: white;
`

export const NewBadge = () => <NewBadgeContainer>{translations.general.new}</NewBadgeContainer>

/* ********* Recurring Badge ********* */

const RecurringBadgeContainer = styled.span`
  padding: 5px;
  background: ${styles.colors.buttonDarkColor};
  border-radius: 10px;
`
export const RecurringBadge = () => (
  <RecurringBadgeContainer>
    <FaRetweet color="white" size={14} />
  </RecurringBadgeContainer>
)

/* ********* Review Badge ********* */

const ReviewBadgeContainer = styled.span`
  padding: 0px 8px;
  background: ${styles.colors.buttonLightColor};
  border-radius: 10px;
  color: ${styles.colors.textRegularColor};
  font-weight: 500;
  font-size: 12px;
  line-height: 28px;
`

export const ReviewBadge = ({ text, style = {} }) => <ReviewBadgeContainer style={style}>{text}</ReviewBadgeContainer>

/* ********* Open Task Label ********* */

const OpenTaskLabelContainer = styled.div`
  color: ${styles.colors.darkGrey};
  font-size: ${styles.fonts.fontSizeSmall};
  float: right;
  line-height: 28px;
`

export const OpenTaskLabel = () => (
  <OpenTaskLabelContainer className="open-task-label">
    <Icon size={16} icon="ExternalLink" style={{ display: 'inline-block', verticalAlign: 'middle' }} />
    <div style={{ marginLeft: 8, display: 'inline-block', verticalAlign: 'middle' }}>
      {translations.onboarding.tasks.openTask}
    </div>
  </OpenTaskLabelContainer>
)

/* ********* Tag ********* */
// we need a tag container otherwise TagBadge isn't centered
// in the line
const TagContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const TagBadge = styled.div`
  transition: max-width 0.2s linear;
  color: ${props => props.color};
  background-color: ${props => props.backgroundColor};
  height: 24px;
  min-width: 24px;
  max-width: ${props => (props.hover ? '120px' : '24px')};
  border-radius: 10px;
  padding: ${props => (props.hover ? '0 5px' : '0')};
  display: flex;
  align-items: center;
  justify-content: ${props => (props.hover ? 'flex-start' : 'center')};
  flex-shrink: 0;
  margin-right: 4px;
  font-weight: 500;
  font-size: 12px;
  span {
    display: inline;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

export class Tag extends Component {
  constructor(props) {
    super(props)
    this.state = { hover: false }
  }
  handleMouseEnter = () => {
    this.setState({ hover: true })
  }

  handleMouseLeave = () => {
    this.setState({ hover: false })
  }

  render() {
    const { label, name, color, backgroundColor } = this.props
    const { hover } = this.state
    return (
      <TagContainer>
        <TagBadge
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          color={color}
          backgroundColor={backgroundColor}
          hover={hover}>
          <span>{hover ? name : label}</span>
        </TagBadge>
      </TagContainer>
    )
  }
}

/* ********* Old Task Badge ********* */

const OldTaskBadgeContainer = styled.div`
  display: inline-block;
  position: relative;
  margin-right: 4px;
  margin-top: 2px;
  ${media['phone-wide']`
 margin-top: 0px;
`}
`

export const OldTaskBadge = ({ creationTime }) => {
  const label = utils.badges.getOldTaskLabel(creationTime)
  return (
    <OldTaskBadgeContainer>
      <Icon
        size={16}
        icon="HourglassEnd"
        style={{ display: 'inline-block', verticalAlign: 'middle', marginBottom: '3px' }}
      />
      <Tooltip text={label} vs={40} hs={15} position="top right" />
    </OldTaskBadgeContainer>
  )
}



// WEBPACK FOOTER //
// ./src/features/list/components/line/components/badges.js